const debtToCashflowsData = [
  {
    month: ["2021", "Aug"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1056302.74,
    totalDebt: 5934705.0,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 605038.99,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 8.43,
    netDebtToEbitda: -19.48,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 836829.02,
    ebitda: -261682.45,
    netDebtToRevenue: 4.83,
  },
  {
    month: ["2021", "Sep"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 829310.85,
    totalDebt: 6490470.32,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 415743.79,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 14.69,
    netDebtToEbitda: -8.59,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 383270.55,
    ebitda: -710855.77,
    netDebtToRevenue: 7.36,
  },
  {
    month: ["2021", "Oct"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 2061491.35,
    totalDebt: 6357936.11,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 1222946.13,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 4.54,
    netDebtToEbitda: 190.23,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 801144.55,
    ebitda: 29210.15,
    netDebtToRevenue: 2.7,
  },
  {
    month: ["2021", "Nov"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 3116471.59,
    totalDebt: 6156903.37,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 1849843.97,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 2.54,
    netDebtToEbitda: 21.01,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 1453189.69,
    ebitda: 223837.94,
    netDebtToRevenue: 1.51,
  },
  {
    month: ["2021", "Dec"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 3247412.49,
    totalDebt: 5960235.29,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 1838581.56,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 2.1,
    netDebtToEbitda: -29.01,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 2093477.41,
    ebitda: -133300.42,
    netDebtToRevenue: 1.19,
  },
  {
    month: ["2022", "Jan"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1225423.81,
    totalDebt: 5934705.0,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 541221.17,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 9.18,
    netDebtToEbitda: -10.0,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 965303.76,
    ebitda: -496804.59,
    netDebtToRevenue: 4.06,
  },
  {
    month: ["2022", "Feb"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1488528.38,
    totalDebt: 6760812.11,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 882590.77,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 6.11,
    netDebtToEbitda: -16.13,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 1371971.53,
    ebitda: -334126.64,
    netDebtToRevenue: 3.62,
  },
  {
    month: ["2022", "Mar"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1370241.74,
    totalDebt: 6611734.23,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 758729.43,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 8.25,
    netDebtToEbitda: -27.53,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 349492.07,
    ebitda: -227476.2,
    netDebtToRevenue: 4.57,
  },
  {
    month: ["2022", "Apr"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 997813.92,
    totalDebt: 7521041.84,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 504036.65,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 14.09,
    netDebtToEbitda: -14.96,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 421236.79,
    ebitda: -474566.67,
    netDebtToRevenue: 7.12,
  },
  {
    month: ["2022", "May"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1276291.23,
    totalDebt: 7380070.88,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 751475.78,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 9.66,
    netDebtToEbitda: -25.65,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 119722.82,
    ebitda: -283093.72,
    netDebtToRevenue: 5.69,
  },
  {
    month: ["2022", "Jun"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1147775.8,
    totalDebt: 8193762.49,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 620542.55,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 12.54,
    netDebtToEbitda: -23.71,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 412926.4,
    ebitda: -328131.99,
    netDebtToRevenue: 6.78,
  },
  {
    month: ["2022", "Jul"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 968255.47,
    totalDebt: 8901556.23,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 490408.33,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 17.14,
    netDebtToEbitda: -19.73,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 496691.42,
    ebitda: -426064.94,
    netDebtToRevenue: 8.68,
  },
  {
    month: ["2022", "Aug"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1460722.01,
    totalDebt: 8642556.11,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 733338.54,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 11.38,
    netDebtToEbitda: -36.05,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 299495.54,
    ebitda: -231432.52,
    netDebtToRevenue: 5.71,
  },
  {
    month: ["2022", "Sep"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 903691.02,
    totalDebt: 9036263.37,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 434959.17,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 20.44,
    netDebtToEbitda: -9.79,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 144536.11,
    ebitda: -908612.45,
    netDebtToRevenue: 9.84,
  },
  {
    month: ["2022", "Oct"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 2572904.85,
    totalDebt: 8938266.3,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 1607418.18,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 5.24,
    netDebtToEbitda: -203.88,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 511916.49,
    ebitda: -41330.69,
    netDebtToRevenue: 3.28,
  },
  {
    month: ["2022", "Nov"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 4061811.53,
    totalDebt: 8401465.87,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 2545935.17,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 2.71,
    netDebtToEbitda: 6.92,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 1500152.8,
    ebitda: 996662.53,
    netDebtToRevenue: 1.7,
  },
  {
    month: ["2022", "Dec"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 3473715.02,
    totalDebt: 7419475.0,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 1971616.57,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 3.37,
    netDebtToEbitda: 7.26,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 776161.2,
    ebitda: 915443.82,
    netDebtToRevenue: 1.91,
  },
  {
    month: ["2023", "Jan"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1457363.91,
    totalDebt: 8350488.2,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 720973.17,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 9.51,
    netDebtToEbitda: -16.76,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 1496772.12,
    ebitda: -408923.78,
    netDebtToRevenue: 4.7,
  },
  {
    month: ["2023", "Feb"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 651704.91,
    totalDebt: 8186478.09,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 362867.12,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 22.46,
    netDebtToEbitda: -18.61,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 35759.9,
    ebitda: -437982.85,
    netDebtToRevenue: 12.51,
  },
  {
    month: ["2023", "Mar"],
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    totalRevenue: 1064881.14,
    totalDebt: 8532644.87,
    netDebtToEbitdaFromRemittanceReport: null,
    preMarketingEbitda: 620772.96,
    netDebtFromRemittanceReport: null,
    netDebtToPreMarketingEbitda: 13.21,
    netDebtToEbitda: -30.58,
    netDebtToRevenueFromRemittanceReport: null,
    netDebtToPreMarketingEbitdaFromRemittanceReport: null,
    cash: 330112.56,
    ebitda: -268249.95,
    netDebtToRevenue: 7.7,
  },
  {
    month: ["2023", "Apr"],
    balanceAvgInPeriod: 375000.0,
    debtBalanceEop: 750000.0,
    totalRevenue: 644017.64,
    totalDebt: 9144386.24,
    netDebtToEbitdaFromRemittanceReport: 0.11,
    preMarketingEbitda: 362507.38,
    netDebtFromRemittanceReport: -459658.4,
    netDebtToPreMarketingEbitda: 22.92,
    netDebtToEbitda: -22.93,
    netDebtToRevenueFromRemittanceReport: -0.06,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.11,
    cash: 834658.4,
    ebitda: -362322.35,
    netDebtToRevenue: 12.9,
  },
  {
    month: ["2023", "May"],
    balanceAvgInPeriod: 1125000.0,
    debtBalanceEop: 1500000.0,
    totalRevenue: 970982.72,
    totalDebt: 9692323.5,
    netDebtToEbitdaFromRemittanceReport: 0.04,
    preMarketingEbitda: 567370.78,
    netDebtFromRemittanceReport: -64551.45,
    netDebtToPreMarketingEbitda: 14.99,
    netDebtToEbitda: -61.52,
    netDebtToRevenueFromRemittanceReport: -0.01,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.01,
    cash: 1189551.45,
    ebitda: -138217.53,
    netDebtToRevenue: 8.76,
  },
  {
    month: ["2023", "Jun"],
    balanceAvgInPeriod: 1500000.0,
    debtBalanceEop: 1500000.0,
    totalRevenue: 669718.47,
    totalDebt: 9943909.91,
    netDebtToEbitdaFromRemittanceReport: -0.49,
    preMarketingEbitda: 356721.22,
    netDebtFromRemittanceReport: 646226.77,
    netDebtToPreMarketingEbitda: 25.48,
    netDebtToEbitda: -82.3,
    netDebtToRevenueFromRemittanceReport: 0.08,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.15,
    cash: 853773.23,
    ebitda: -110445.3,
    netDebtToRevenue: 13.57,
  },
  {
    month: ["2023", "Jul"],
    balanceAvgInPeriod: 1500000.0,
    debtBalanceEop: 1500000.0,
    totalRevenue: 744590.0,
    totalDebt: 9865314.61,
    netDebtToEbitdaFromRemittanceReport: -0.3,
    preMarketingEbitda: 364889.98,
    netDebtFromRemittanceReport: 934053.46,
    netDebtToPreMarketingEbitda: 25.49,
    netDebtToEbitda: -35.58,
    netDebtToRevenueFromRemittanceReport: 0.1,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.21,
    cash: 565946.54,
    ebitda: -261339.09,
    netDebtToRevenue: 12.49,
  },
  {
    month: ["2023", "Aug"],
    balanceAvgInPeriod: 1482839.79,
    debtBalanceEop: 1465679.57,
    totalRevenue: 1461633.43,
    totalDebt: 9640737.11,
    netDebtToEbitdaFromRemittanceReport: 0.08,
    preMarketingEbitda: 860538.95,
    netDebtFromRemittanceReport: 431595.92,
    netDebtToPreMarketingEbitda: 9.98,
    netDebtToEbitda: 17.93,
    netDebtToRevenueFromRemittanceReport: 0.02,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.04,
    cash: 1051243.87,
    ebitda: 478974.27,
    netDebtToRevenue: 5.88,
  },
  {
    month: ["2023", "Sep"],
    balanceAvgInPeriod: 1430976.56,
    debtBalanceEop: 1396273.54,
    totalRevenue: 1148165.85,
    totalDebt: 9443092.5,
    netDebtToEbitdaFromRemittanceReport: -0.3,
    preMarketingEbitda: 647090.12,
    netDebtFromRemittanceReport: 1201651.94,
    netDebtToPreMarketingEbitda: 14.24,
    netDebtToEbitda: -27.89,
    netDebtToRevenueFromRemittanceReport: 0.09,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.15,
    cash: 229324.62,
    ebitda: -330344.04,
    netDebtToRevenue: 8.02,
  },
  {
    month: ["2023", "Oct"],
    balanceAvgInPeriod: 1360796.82,
    debtBalanceEop: 1325320.1,
    totalRevenue: 2708776.66,
    totalDebt: 9539217.66,
    netDebtToEbitdaFromRemittanceReport: 0.07,
    preMarketingEbitda: 1758525.62,
    netDebtFromRemittanceReport: 183101.38,
    netDebtToPreMarketingEbitda: 4.75,
    netDebtToEbitda: 38.91,
    netDebtToRevenueFromRemittanceReport: 0.01,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.01,
    cash: 1177695.44,
    ebitda: 214908.24,
    netDebtToRevenue: 3.09,
  },
  {
    month: ["2023", "Nov"],
    balanceAvgInPeriod: 1289052.43,
    debtBalanceEop: 1252784.75,
    totalRevenue: 4042095.01,
    totalDebt: 9141559.4,
    netDebtToEbitdaFromRemittanceReport: -0.12,
    preMarketingEbitda: 2573849.95,
    netDebtFromRemittanceReport: -1464857.74,
    netDebtToPreMarketingEbitda: 2.48,
    netDebtToEbitda: 6.1,
    netDebtToRevenueFromRemittanceReport: -0.03,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.05,
    cash: 2753910.17,
    ebitda: 1047403.41,
    netDebtToRevenue: 1.58,
  },
  {
    month: ["2023", "Dec"],
    balanceAvgInPeriod: 1215708.49,
    debtBalanceEop: 1178632.23,
    totalRevenue: 3560257.66,
    totalDebt: 9410963.79,
    netDebtToEbitdaFromRemittanceReport: -0.1,
    preMarketingEbitda: 2127809.68,
    netDebtFromRemittanceReport: -1407423.33,
    netDebtToPreMarketingEbitda: 3.19,
    netDebtToEbitda: 5.94,
    netDebtToRevenueFromRemittanceReport: -0.03,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.06,
    cash: 2623131.82,
    ebitda: 1142678.98,
    netDebtToRevenue: 1.91,
  },
  {
    month: ["2024", "Jan"],
    balanceAvgInPeriod: 1140729.35,
    debtBalanceEop: 1102826.48,
    totalRevenue: 1357548.17,
    totalDebt: 9410232.79,
    netDebtToEbitdaFromRemittanceReport: 0.29,
    preMarketingEbitda: 704527.9,
    netDebtFromRemittanceReport: -997306.85,
    netDebtToPreMarketingEbitda: 10.32,
    netDebtToEbitda: -25.24,
    netDebtToRevenueFromRemittanceReport: -0.06,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.12,
    cash: 2138036.21,
    ebitda: -288098.75,
    netDebtToRevenue: 5.36,
  },
  {
    month: ["2024", "Feb"],
    balanceAvgInPeriod: 1064078.56,
    debtBalanceEop: 1025330.64,
    totalRevenue: 1412332.92,
    totalDebt: 9205335.13,
    netDebtToEbitdaFromRemittanceReport: 1.53,
    preMarketingEbitda: 852442.72,
    netDebtFromRemittanceReport: -500775.29,
    netDebtToPreMarketingEbitda: 8.96,
    netDebtToEbitda: -279.72,
    netDebtToRevenueFromRemittanceReport: -0.03,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.05,
    cash: 1564853.85,
    ebitda: -27314.47,
    netDebtToRevenue: 5.41,
  },
  {
    month: ["2024", "Mar"],
    balanceAvgInPeriod: 985718.83,
    debtBalanceEop: 946107.03,
    totalRevenue: 1109826.56,
    totalDebt: 9102520.8,
    netDebtToEbitdaFromRemittanceReport: 0.15,
    preMarketingEbitda: 666606.51,
    netDebtFromRemittanceReport: -236033.68,
    netDebtToPreMarketingEbitda: 11.82,
    netDebtToEbitda: -60.58,
    netDebtToRevenueFromRemittanceReport: -0.02,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.03,
    cash: 1221752.51,
    ebitda: -130093.38,
    netDebtToRevenue: 7.1,
  },
  {
    month: ["2024", "Apr"],
    balanceAvgInPeriod: 905612.08,
    debtBalanceEop: 865117.13,
    totalRevenue: 854810.07,
    totalDebt: 8999706.47,
    netDebtToEbitdaFromRemittanceReport: -0.18,
    preMarketingEbitda: 491998.35,
    netDebtFromRemittanceReport: 486285.03,
    netDebtToPreMarketingEbitda: 17.44,
    netDebtToEbitda: -37.7,
    netDebtToRevenueFromRemittanceReport: 0.05,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.08,
    cash: 419327.05,
    ebitda: -227585.66,
    netDebtToRevenue: 10.04,
  },
  {
    month: ["2024", "May"],
    balanceAvgInPeriod: 775198.94,
    debtBalanceEop: 685280.75,
    totalRevenue: 1304298.49,
    totalDebt: 10414365.17,
    netDebtToEbitdaFromRemittanceReport: -0.64,
    preMarketingEbitda: 739394.2,
    netDebtFromRemittanceReport: -983062.19,
    netDebtToPreMarketingEbitda: 11.71,
    netDebtToEbitda: 67.34,
    netDebtToRevenueFromRemittanceReport: -0.06,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.11,
    cash: 1758261.13,
    ebitda: 128549.29,
    netDebtToRevenue: 6.64,
  },
  {
    month: ["2024", "Jun"],
    balanceAvgInPeriod: 647279.1,
    debtBalanceEop: 609277.46,
    totalRevenue: 778806.57,
    totalDebt: 10238265.5,
    netDebtToEbitdaFromRemittanceReport: 0.39,
    preMarketingEbitda: 423225.13,
    netDebtFromRemittanceReport: -678081.44,
    netDebtToPreMarketingEbitda: 21.06,
    netDebtToEbitda: -61.29,
    netDebtToRevenueFromRemittanceReport: -0.07,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.13,
    cash: 1325360.54,
    ebitda: -145428.41,
    netDebtToRevenue: 11.44,
  },
  {
    month: ["2024", "Jul"],
    balanceAvgInPeriod: 570809.25,
    debtBalanceEop: 532341.04,
    totalRevenue: 819763.32,
    totalDebt: 10038781.02,
    netDebtToEbitdaFromRemittanceReport: -0.02,
    preMarketingEbitda: 391749.68,
    netDebtFromRemittanceReport: 114210.82,
    netDebtToPreMarketingEbitda: 24.46,
    netDebtToEbitda: -18.13,
    netDebtToRevenueFromRemittanceReport: 0.01,
    netDebtToPreMarketingEbitdaFromRemittanceReport: 0.02,
    cash: 456598.43,
    ebitda: -528576.95,
    netDebtToRevenue: 11.69,
  },
  {
    month: ["2024", "Aug"],
    balanceAvgInPeriod: 493395.85,
    debtBalanceEop: 454450.67,
    totalRevenue: 1212828.82,
    totalDebt: 9770639.62,
    netDebtToEbitdaFromRemittanceReport: -0.08,
    preMarketingEbitda: 715214.82,
    netDebtFromRemittanceReport: -21912.51,
    netDebtToPreMarketingEbitda: 12.94,
    netDebtToEbitda: 405.96,
    netDebtToRevenueFromRemittanceReport: -0.0,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.0,
    cash: 515308.36,
    ebitda: 22798.87,
    netDebtToRevenue: 7.63,
  },
  {
    month: ["2024", "Sep"],
    balanceAvgInPeriod: 415017.88,
    debtBalanceEop: 375585.09,
    totalRevenue: 1310645.84,
    totalDebt: 9504984.04,
    netDebtToEbitdaFromRemittanceReport: 0.02,
    preMarketingEbitda: 735601.58,
    netDebtFromRemittanceReport: -59486.34,
    netDebtToPreMarketingEbitda: 12.28,
    netDebtToEbitda: -29.88,
    netDebtToRevenueFromRemittanceReport: -0.0,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.01,
    cash: 474504.22,
    ebitda: -302181.54,
    netDebtToRevenue: 6.89,
  },
  {
    month: ["2024", "Oct"],
    balanceAvgInPeriod: 335653.82,
    debtBalanceEop: 295722.56,
    totalRevenue: 1992038.87,
    totalDebt: 9112023.28,
    netDebtToEbitdaFromRemittanceReport: 0.32,
    preMarketingEbitda: 1254771.22,
    netDebtFromRemittanceReport: -644569.1,
    netDebtToPreMarketingEbitda: 6.48,
    netDebtToEbitda: -48.73,
    netDebtToRevenueFromRemittanceReport: -0.03,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.04,
    cash: 980222.92,
    ebitda: -166876.94,
    netDebtToRevenue: 4.08,
  },
  {
    month: ["2024", "Nov"],
    balanceAvgInPeriod: 255281.7,
    debtBalanceEop: 214840.85,
    totalRevenue: 3168315.18,
    totalDebt: 9344280.79,
    netDebtToEbitdaFromRemittanceReport: -0.13,
    preMarketingEbitda: 1989808.77,
    netDebtFromRemittanceReport: -1441010.91,
    netDebtToPreMarketingEbitda: 3.84,
    netDebtToEbitda: 8.45,
    netDebtToRevenueFromRemittanceReport: -0.04,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.06,
    cash: 1696292.61,
    ebitda: 904849.13,
    netDebtToRevenue: 2.41,
  },
  {
    month: ["2024", "Dec"],
    balanceAvgInPeriod: 173879.04,
    debtBalanceEop: 132917.24,
    totalRevenue: 4392768.15,
    totalDebt: 9294593.28,
    netDebtToEbitdaFromRemittanceReport: -0.29,
    preMarketingEbitda: 2620464.6,
    netDebtFromRemittanceReport: -2401088.75,
    netDebtToPreMarketingEbitda: 2.56,
    netDebtToEbitda: 9.74,
    netDebtToRevenueFromRemittanceReport: -0.05,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.08,
    cash: 2574967.8,
    ebitda: 689865.96,
    netDebtToRevenue: 1.53,
  },
  {
    month: ["2025", "Jan"],
    balanceAvgInPeriod: 91422.87,
    debtBalanceEop: 49928.5,
    totalRevenue: 1200761.65,
    totalDebt: 9207403.95,
    netDebtToEbitdaFromRemittanceReport: 0.23,
    preMarketingEbitda: 616446.92,
    netDebtFromRemittanceReport: -1492601.99,
    netDebtToPreMarketingEbitda: 12.37,
    netDebtToEbitda: -14.06,
    netDebtToRevenueFromRemittanceReport: -0.1,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.2,
    cash: 1584024.86,
    ebitda: -542199.64,
    netDebtToRevenue: 6.35,
  },
  {
    month: ["2025", "Feb"],
    balanceAvgInPeriod: 24964.24,
    debtBalanceEop: -0.01,
    totalRevenue: 1364382.34,
    totalDebt: 9083544.83,
    netDebtToEbitdaFromRemittanceReport: 3.03,
    preMarketingEbitda: 807910.29,
    netDebtFromRemittanceReport: -1622614.34,
    netDebtToPreMarketingEbitda: 9.2,
    netDebtToEbitda: -166.37,
    netDebtToRevenueFromRemittanceReport: -0.1,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.17,
    cash: 1647578.58,
    ebitda: -44694.79,
    netDebtToRevenue: 5.45,
  },
  {
    month: ["2025", "Mar"],
    balanceAvgInPeriod: 849999.99,
    debtBalanceEop: 849999.99,
    totalRevenue: 1520812.98,
    totalDebt: 9922188.83,
    netDebtToEbitdaFromRemittanceReport: -1.51,
    preMarketingEbitda: 953225.48,
    netDebtFromRemittanceReport: -2030371.5,
    netDebtToPreMarketingEbitda: 7.83,
    netDebtToEbitda: 66.52,
    netDebtToRevenueFromRemittanceReport: -0.11,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.18,
    cash: 2455371.49,
    ebitda: 112243.9,
    netDebtToRevenue: 4.91,
  },
  {
    month: ["2025", "Apr"],
    balanceAvgInPeriod: 849999.99,
    debtBalanceEop: 849999.99,
    totalRevenue: 725728.68,
    totalDebt: 9910832.83,
    netDebtToEbitdaFromRemittanceReport: 0.17,
    preMarketingEbitda: 384629.32,
    netDebtFromRemittanceReport: -854202.33,
    netDebtToPreMarketingEbitda: 21.34,
    netDebtToEbitda: -19.76,
    netDebtToRevenueFromRemittanceReport: -0.1,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.19,
    cash: 1704202.32,
    ebitda: -415232.58,
    netDebtToRevenue: 11.31,
  },
  {
    month: ["2025", "May"],
    balanceAvgInPeriod: 849999.99,
    debtBalanceEop: 849999.99,
    totalRevenue: 1109996.95,
    totalDebt: 9830157.41,
    netDebtToEbitdaFromRemittanceReport: 0.69,
    preMarketingEbitda: 668277.06,
    netDebtFromRemittanceReport: -903981.92,
    netDebtToPreMarketingEbitda: 12.09,
    netDebtToEbitda: -74.38,
    netDebtToRevenueFromRemittanceReport: -0.07,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.11,
    cash: 1753981.91,
    ebitda: -108584.43,
    netDebtToRevenue: 7.28,
  },
  {
    month: ["2025", "Jun"],
    balanceAvgInPeriod: 1680551.74,
    debtBalanceEop: 1661103.5,
    totalRevenue: 765991.16,
    totalDebt: 9830157.41,
    netDebtToEbitdaFromRemittanceReport: -0.09,
    preMarketingEbitda: 437507.34,
    netDebtFromRemittanceReport: -405455.82,
    netDebtToPreMarketingEbitda: 18.67,
    netDebtToEbitda: 21.42,
    netDebtToRevenueFromRemittanceReport: -0.04,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.08,
    cash: 1661007.56,
    ebitda: 381408.26,
    netDebtToRevenue: 10.66,
  },
  {
    month: ["2025", "Jul"],
    balanceAvgInPeriod: 1641221.66,
    debtBalanceEop: 1621339.82,
    totalRevenue: 37494.53,
    totalDebt: 9830157.41,
    netDebtToEbitdaFromRemittanceReport: -0.16,
    preMarketingEbitda: 23722.46,
    netDebtFromRemittanceReport: -43087.41,
    netDebtToPreMarketingEbitda: 343.38,
    netDebtToEbitda: 374.19,
    netDebtToRevenueFromRemittanceReport: -0.1,
    netDebtToPreMarketingEbitdaFromRemittanceReport: -0.15,
    cash: 1684309.07,
    ebitda: 21769.13,
    netDebtToRevenue: 217.25,
  },
];

export default debtToCashflowsData;
